import { render, staticRenderFns } from "./mainBadges.vue?vue&type=template&id=8c2fb19a&scoped=true&"
import script from "./mainBadges.vue?vue&type=script&lang=js&"
export * from "./mainBadges.vue?vue&type=script&lang=js&"
import style0 from "./mainBadges.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mainBadges.vue?vue&type=style&index=1&id=8c2fb19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2fb19a",
  null
  
)

export default component.exports